module.exports = __webpack_public_path__ + "img/betting.adba0aa4.jpg";